export default {
    install(Vue) {
        // eslint-disable-next-line consistent-return
        Vue.prototype.$dataSorting = function (data, name) {
            if (data) {
                let finalData = {};
                const map = {};
                const dest = [];
                const indexList = [];
                const user_id = this.$takeTokenParameters('Uid');
                data.forEach(item => {
                    if (item.friend_id !== user_id) {
                        if (item[name] === null || item[name] === 'null' || item[name] === '') {
                            item[name] = '匿名';
                        }
                        item.icon = item[name][0];
                        item.Initial = item[name][0].spell('first', 'low').toUpperCase();
                        item.Initials = item[name].spell('first', 'low');
                        if (indexList.indexOf(item.Initial) === -1) {
                            indexList.push(item.Initial);
                        }
                        const ai = item;
                        if (!map[ai.Initial]) {
                            dest.push({
                                Initial: ai.Initial,
                                data: [ai],
                            });
                            map[ai.Initial] = ai;
                        } else {
                            for (let j = 0; j < dest.length; j++) {
                                const dj = dest[j];
                                if (dj.Initial === ai.Initial) {
                                    dj.data.push(ai);
                                    break;
                                }
                            }
                        }
                    }
                });
                dest.sort((a, b) => a.Initial.charCodeAt(0) - b.Initial.charCodeAt(0));

                finalData = {
                    dataList: dest,
                    indexList: indexList.sort(),
                };

                return finalData;
            }
        };
    },
};